import { useMemo } from "react";
import { FILTERS_CONFIG, getDefaultValue } from "./GlobalFilterPanel";
import { useReportFilterOptions } from "./useReportFilterOptions";
import {
  buildCascadedDropdownOptions,
  expandAllFilterSelections,
} from "./filterRelationshipUtils";

/**
 * Dropdown options for the filter bar (draft-cascaded) plus applied filters
 * with All sentinels expanded to concrete option lists for API calls.
 */
export function useExpandedAppliedFilters(appliedFilters, draftFilters, visibleKeys) {
  const { dropdownOptions, relationshipRows, baseOptions } = useReportFilterOptions(
    draftFilters,
    visibleKeys,
  );

  const appliedDropdownOptions = useMemo(
    () =>
      buildCascadedDropdownOptions(
        relationshipRows,
        baseOptions,
        appliedFilters,
        visibleKeys,
      ),
    [relationshipRows, baseOptions, appliedFilters, visibleKeys],
  );

  const effectiveFilters = useMemo(() => {
    const visible = new Set(visibleKeys || FILTERS_CONFIG.map((f) => f.key));
    const next = { ...appliedFilters };
    FILTERS_CONFIG.forEach((f) => {
      if (!visible.has(f.key)) next[f.key] = getDefaultValue(f);
    });
    return expandAllFilterSelections(next, appliedDropdownOptions);
  }, [appliedFilters, visibleKeys, appliedDropdownOptions]);

  return {
    dropdownOptions,
    relationshipRows,
    baseOptions,
    appliedDropdownOptions,
    effectiveFilters,
  };
}
